export type TelehealthBlockReason = "recording" | "safari";

export function isSafariBrowser(userAgent: string): boolean {
  const ua = userAgent.toLowerCase();
  return ua.indexOf("safari") !== -1 && ua.indexOf("chrome") === -1;
}

export function canEnableTelehealth(input: { isRecording: boolean; isSafari: boolean }): {
  allowed: boolean;
  reason?: TelehealthBlockReason;
} {
  if (input.isRecording) {
    return { allowed: false, reason: "recording" };
  }
  if (input.isSafari) {
    return { allowed: false, reason: "safari" };
  }
  return { allowed: true };
}

export function shouldAutoSetupMicrophone(input: {
  isTelehealth: boolean;
  hasMicrophone: boolean;
  alreadyAttempted: boolean;
}): boolean {
  return input.isTelehealth && !input.hasMicrophone && !input.alreadyAttempted;
}

export function shouldResetTelehealthOnClose(audio: {
  hasMicrophone: boolean;
  hasScreenAudio: boolean;
}): boolean {
  return !audio.hasMicrophone || !audio.hasScreenAudio;
}

export function shouldClearTelehealthWhenSourcesLost(input: {
  isTelehealth: boolean;
  hasMicrophone: boolean;
  hasScreenAudio: boolean;
}): boolean {
  return input.isTelehealth && !input.hasMicrophone && !input.hasScreenAudio;
}

export function shouldAttemptEnrichment(input: {
  hasEnriched: boolean;
  isStandalone: boolean;
  hasAppointmentId: boolean;
}): boolean {
  return !input.hasEnriched && !input.isStandalone && input.hasAppointmentId;
}

export function resolvePatientId(
  routeParam?: string,
  locationPatientId?: string | number | null
): string | undefined {
  if (
    locationPatientId !== undefined &&
    locationPatientId !== null &&
    String(locationPatientId) !== ""
  ) {
    return String(locationPatientId);
  }
  if (routeParam) {
    return routeParam;
  }
  return undefined;
}
